<template>
<div class="project">
  <BContainer class="page">
    <BRow>
      <BCol
        class="content-section"
        :lg="8"
        :sm="12">
        <div class="header">
          <h1 class="display-4 my-4">
            {{ projectLabel }}
          </h1>
        </div>
        <component
          v-if="file"
          :is="file"/>
        <div v-else class="missing-project-file">
          <p>
            That project file seems to be missing
          </p>
        </div>

      </BCol>

      <BCol
        :lg="4"
        :sm="12"
        class="related">
        <div v-if="related.length">
          <h5>
            Related news
          </h5>
          <ul>
            <li
              v-for="r in related"
              :key="r.uid">
              <router-link
                :to="`/stories/${r.uid}`">
                {{ r.label }}
              </router-link>
            </li>
          </ul>
        </div>
        <h5>
          Other Projects
        </h5>
        <ul>
          <li
            v-for="p in otherProjects"
            :key="p.uid">
            <router-link
              :to="`/projects/${p.uid}`">
              {{ p.label }}
            </router-link>
          </li>
        </ul>
      </BCol>
    </BRow>
  </BContainer>


  <div
    class="modal"
    :class="{ visible: !!image }"
    v-if="image">
    <div class="modal-background">
      <a
        @click="closeImage">
        <BImg
          class="ignore screen-size"
          :src="`${image}`"/>
      </a>
    </div>
  </div>

  <ContactPanel
    :subject="projectData.uid">
    <h3>Want to learn more about this project?</h3>
    <p>
      Drop us an email and we will be happy to tell you more.
    </p>

  </ContactPanel>

</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import FullScreenImage from '@/mixins/FullScreenImage';
import ScrollIntoView from '@/mixins/ScrollIntoView';
import ContactPanel from '@/components/sections/ContactPanel';
import {
  BContainer,
  BRow,
  BCol,
  BImg,
} from 'bootstrap-vue'

export default {
  name: 'Project',
  mixins: [
    FullScreenImage,
    ScrollIntoView,
  ],
  props: {
    uid: String
  },
  data() {
    return {};
  },
  components: {
    ContactPanel,
    'b-container': BContainer,
    'b-img': BImg,
    'b-row': BRow,
    'b-col': BCol,
  },
  created() {
    this.pageView(`projects/${this.uid}`)
  },
  watch: {
    uid(a){
      this.pageView(`project/${a}`)
    }
  },
  computed: {
    ...mapState([
      'projects',
      'gaid'
    ]),
    ...mapGetters([
      'activeProjects',
      'activeNews',
    ]),
    otherProjects(){
      return this.activeProjects
        .filter(d=>d.uid!==this.uid)
    },
    image(){
      const query = this.$route.query;
      return query.image;
    },
    projectData(){
      return this.projects.find( d => d.uid === this.uid);
    },
    projectLabel(){
      return this.projectData.label;
    },
    related(){
      const tags = [this.uid, ...(this.projectData.tags||[])];
      return this.activeNews
        .filter( d => d.tags.some( a => tags.includes(a)))
    },
    file(){
      if(!this.uid) return;
      try {
        var md = require(`@/projects/${this.uid}/content.md`).default;
        return md;
      } catch (err) {
        //console.log('Couldnt load file', err)
      }
    },
    src(){
      const img = this.projectData.image;
      try{
        return require(`@/assets/img/${img}`);
      } catch(err){
        //let i = Math.round(Math.random()*50+1)
        //return `https://picsum.photos/400/400/?image=${i}`
      }
    }
  },
  methods: {
    ...mapActions([
      'pageView'
    ]),
    closeImage(){
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss">
@import '~@/styles/variables';
@import '~@/styles/markdown';

.project  {

  .header {
    display: flex;
    .title-image {
      width: 33%;
      margin-right: 1rem;
    }
    text-transform: capitalize;
    //border-bottom: $border-style;
    //padding-bottom: 1rem;
    //margin-bottom: 1rem;
  }

  .modal {
    &.visible {
      display: block;
      background-color: rgba(0,0,0,0.7);

      img {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        max-width: 95%;
        max-height: 100%;
        margin: auto;
        overflow: auto;
      }
    }
  }


  .page {
    display: flex;
    //width: 60rem;
    margin: 0 auto;

    .related {
      //flex: 0 0 10rem;
      border-left: 1px solid rgba(0,0,0,0.1);
      padding-left: 1rem;
      margin-top: 5rem;
    }

    .content-section {
      min-height: 30rem;
      @include image;
    }

  }

}
</style>
